import FilterTranslatorConverter from '../FilterTranslatorConverter';
const filterTranslator = {
  locator: () => {
    return {
      type: 'logical',
      operator: 'and',
      conditions: [{
        type: 'equals',
        field: 'data/type',
        value: 'vehicle-with-locator'
      }, {
        type: 'logical',
        operator: 'or',
        conditions: [{
          type: 'equals',
          field: 'data/productTypes/recovr',
          value: true
        }, {
          type: 'exists',
          field: 'data/productTypes/recovr',
          not: true
        }]
      }]
    };
  },
  tags: () => {
    return {
      type: 'equals',
      field: 'data/productTypes/recovrKeys',
      value: true
    };
  }
};
export default FilterTranslatorConverter.create('sale.recovrProductsSold', filterTranslator);